<template>
    <div class="flex flex-col gap-1">
        <span
            class="inline-flex max-w-full items-center gap-2 self-start rounded-full border border-theme-border bg-theme-hover py-1 pl-3 pr-1 text-xs font-medium text-theme-base"
        >
            <span class="truncate">{{ label }}</span>
            <button
                type="button"
                aria-label="Quitar filtro"
                title="Quitar filtro"
                class="flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full text-theme-muted transition hover:bg-theme-card hover:text-theme-base"
                @click="$emit('clear')"
            >
                <x-mark-icon class="h-3 w-3" />
            </button>
        </span>
        <p class="text-xs text-theme-muted">
            Quita el filtro para ver todas tus imágenes, incluidas las
            personalizadas.
        </p>
    </div>
</template>

<script>
import { imageSizeFilterLabel } from "@/common/fields/sizes-images";

import XMarkIcon from "@/components/icons/XMarkIcon.vue";

export default {
    name: "ImageSizeFilterChip",
    components: { XMarkIcon },
    props: {
        size: {
            type: String,
            required: true
        }
    },
    computed: {
        label() {
            return imageSizeFilterLabel(this.size);
        }
    }
};
</script>
